// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__nQzOZ","header":"styles_header__WmIUp","content":"styles_content__7mMvL"};